import '@babel/polyfill';
import 'whatwg-fetch';
import 'vue-toast/dist/vue-toast.min.css';

import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import './plugins/sentry';
import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

require('./libs/w3.css');

require('smoothscroll-polyfill').polyfill();

Vue.use(VueAnalytics, {
  id: 'UA-104189126-1',
  router,
  set: [
    { field: 'anonymizeIp', value: true },
  ],
});

window.emailjs.init('user_oPiLO9wjQgkgN0qgUUlfr');

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n: store.state.i18n,
  router,
  store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js